var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.51,
    height: 7.62,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5200f1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 481",
    d: "M1.274 2.537h9.46a1.27 1.27 0 000-2.54h-9.46a1.27 1.27 0 000 2.54z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 482",
    d: "M15.24 5.08H1.274a1.27 1.27 0 000 2.54h13.97a1.27 1.27 0 000-2.54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenQuestion);
export default __webpack_public_path__ + "static/media/OpenQuestion.83d9f1540c5d3928dd0fa2de16db73cd.svg";
export { ForwardRef as ReactComponent };